function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Triangle");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Voyage-Overview",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.5
}, React.createElement("g", {
  id: "Qronoport---Berth-Overview-Copy",
  transform: "translate(-310.000000, -223.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M312.787653,226.904848 L310.110093,224.221852 C309.993055,224.104576 309.993247,223.914627 310.110523,223.797588 C310.166767,223.741459 310.242981,223.709936 310.32244,223.709936 L315.67756,223.709936 C315.843245,223.709936 315.97756,223.84425 315.97756,224.009936 C315.97756,224.089395 315.946036,224.165609 315.889907,224.221852 L313.212347,226.904848 C313.095309,227.022124 312.905359,227.022316 312.788083,226.905278 C312.78794,226.905135 312.787796,226.904991 312.787653,226.904848 Z",
  id: "Combined-Shape"
})));

var SvgSortableDescending = function SvgSortableDescending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "6px",
    height: "4px",
    viewBox: "0 0 6 4",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSortableDescending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sortable-descending.5e722733.svg";
export { ForwardRef as ReactComponent };